import * as Yup from 'yup';
import { getI18n } from 'react-i18next';

export const getNationalIdValidation = () => {
    const { t } = getI18n();
    return Yup.string()
        .required(t<string>('validation:string.required'))
        .test((val, ctx) => {
            if (!val || !checkFinnishSsn(val)) {
                return ctx.createError({ message: 'Ei kelvollinen henkilötunnus' });
            }
            return true;
        });
};

const SSN_RE = /^(\d{6})[-+abcdefyxwvu](\d{3})([\da-y]){1}$/;
function checkFinnishSsn(ssn: string) {
    ssn = ssn.toLowerCase();
    const m = ssn.match(SSN_RE);

    if (!m) {
        return false;
    }

    const c = [];
    const base = 35;
    const n = parseInt(m[1] + m[2], 10) % 31;

    for (let i = 0; i < base; i++) {
        const e = i.toString(base);
        if ('gioq'.indexOf(e) < 0) {
            c.push(e);
        }
    }

    return c[n] == m[3];
}
